import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b5b0755"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed flex justify-content-around w-full z-1 h-4rem bg-white shadow-3" }
const _hoisted_2 = { class: "flex align-items-center logo-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 text-2xl font-bold text-800" }, "Quokka", -1))
const _hoisted_5 = { class: "flex align-items-center button-container" }
const _hoisted_6 = { id: "home" }
const _hoisted_7 = { class: "main-text col-10 xl:col-7 col-offset-1 lg:col-offset-2 xl:col-offset-3 font-bold text-white" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-5xl lg:text-6xl xl:text-7xl fade-in-up" }, " Monitor data across different websites frequently? ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-6xl lg:text-7xl xl:text-8xl mb-5 fade-in-up animation-delay-1000" }, " We automate it. ", -1))
const _hoisted_10 = {
  id: "features",
  class: "parallax-area flex flex-column xl:flex-row align-items-center justify-content-center p-7 text-800"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "col-12 xl:col-4 p-6 xl:pl-7 xl:-mt-8 xl:-ml-8 text-xl font-medium line-height-2 bg-primary radius-6 shadow-3" }, [
  /*#__PURE__*/_createElementVNode("li", null, "monitor all data in one place."),
  /*#__PURE__*/_createElementVNode("li", null, " Works in password-proof websites (Don’t worry, Quokka won’t ask for or try to access your password!) "),
  /*#__PURE__*/_createElementVNode("li", null, "Quokka fetch the data automatically in the background."),
  /*#__PURE__*/_createElementVNode("li", null, "unlimited number of data (targets), and it’s all free."),
  /*#__PURE__*/_createElementVNode("li", null, "no account is needed."),
  /*#__PURE__*/_createElementVNode("li", null, " Only advanced usage will be asked for an account (such as data backup, data visualization, goal/alert notification, data export, ...). ")
], -1))
const _hoisted_13 = { class: "flex flex-column justify-content-center" }
const _hoisted_14 = { class: "flex align-items-center justify-content-center" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-3 text-4xl font-bold text-800 line-height-2" }, " Click the data on the page you want to monitor. ", -1))
const _hoisted_17 = { class: "flex align-items-center justify-content-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-3 text-4xl font-bold text-800 line-height-2" }, " Watch the data on the panel. Clean and neat! ", -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  id: "tutorial",
  class: "flex align-items-center justify-content-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "video-container" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      class: "video",
      src: "https://www.youtube.com/embed/bJc3CMNZfog",
      allowfullscreen: ""
    })
  ])
], -1))

import Button from "primevue/button";
import { config } from "@/config";
import router from "@/router";
import { Route } from "@evolutivelabs/quokka-common";
import { useAuthStore } from "@/store/auth.store";


const __default__ = {
  name: "Home",
};

function setup(__props) {

const authStore = useAuthStore();
const headerButtons = [
  {
    name: "App",
    onClick() {
      openQuokkaAppStore();
    },
  },
  {
    name: "Features",
    onClick() {
      scrollPageTo("features");
    },
  },
  {
    name: "Tutorial",
    onClick() {
      scrollPageTo("tutorial");
    },
  },
  {
    name: "Privacy",
    onClick() {
      router.push(Route.Privacy);
    },
  },
  {
    name: "Login",
    onClick() {
      authStore.isLoggedIn
        ? router.push(Route.Targets)
        : router.push(Route.Login);
    },
  },
];
const QuokkaLogo = config.LOGO;
const mainPic = {
  backgroundImage: `url(${require("../assets/home-main.jpg")})`,
};
const quokkaUrl =
  "https://chrome.google.com/webstore/detail/quokka-monitor-webpage-da/agoklhpignkeigeeepfpknnhfmgkfihl";

const scrollPageTo = (el: string) => {
  const element = document.querySelector(`#${el}`);
  element?.scrollIntoView({ behavior: "smooth" });
};

const openQuokkaAppStore = () => {
  window.open(quokkaUrl);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(QuokkaLogo),
          alt: "QuokkaLogo",
          class: "h-3rem"
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headerButtons, (item, index) => {
          return _createElementVNode("div", { key: index }, [
            _createVNode(_unref(Button), {
              onClick: _withModifiers(item.onClick, ["prevent"]),
              label: item.name,
              class: "p-button-text font-bold"
            }, null, 8, ["onClick", "label"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("main", {
        class: "main-pic line-height-2 bg-cover bg-center",
        style: mainPic
      }, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _hoisted_9,
          _createVNode(_unref(Button), {
            onClick: openQuokkaAppStore,
            icon: "pi pi-chevron-right",
            label: "Get Started For Free",
            class: "text-2xl font-medium radius-6 p-button-lg p-button-raised fade-in-up animation-delay-1000"
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_10, [
        _createElementVNode("img", {
          class: "col-8 xl:col-6 mt-8 xl:-ml-8",
          src: require('../assets/home-mockup.png'),
          alt: "mockup"
        }, null, 8, _hoisted_11),
        _hoisted_12
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("img", {
            class: "col-3",
            src: require('../assets/home-illustration1.svg'),
            alt: "illustration"
          }, null, 8, _hoisted_15),
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("img", {
            class: "col-3",
            src: require('../assets/home-illustration2.svg'),
            alt: "illustration"
          }, null, 8, _hoisted_19)
        ])
      ]),
      _hoisted_20
    ])
  ], 64))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})